import React from 'react';
import { Box, Button, Chip, Paper, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import { serviceTypes } from 'features/salesOrder/types';

interface BulkSelectionBarProps {
	count: number;
	saleOrderCount: number;
	agencyCount: number;
	isHomogeneous: boolean;
	serviceType: string | null;
	onEdit: () => void;
	onClear: () => void;
}

export const BulkSelectionBar = ({
	count,
	saleOrderCount,
	agencyCount,
	isHomogeneous,
	serviceType,
	onEdit,
	onClear,
}: BulkSelectionBarProps): JSX.Element | null => {
	if (count === 0) return null;

	const typeLabel = serviceType ? serviceTypes.find((item) => item.id === serviceType)?.name ?? serviceType : null;

	return (
		<Paper
			elevation={6}
			sx={{
				position: 'fixed',
				bottom: 24,
				left: '50%',
				transform: 'translateX(-50%)',
				zIndex: 1200,
				px: 2.5,
				py: 1.5,
				display: 'flex',
				alignItems: 'center',
				gap: 2,
				flexWrap: 'wrap',
				borderRadius: 3,
				minWidth: { xs: '92vw', md: 560 },
				maxWidth: '95vw',
			}}
		>
			<Box>
				<Typography variant="subtitle2" fontWeight={600}>
					{count} {count === 1 ? 'servicio seleccionado' : 'servicios seleccionados'}
				</Typography>
				<Typography variant="caption" color="text.secondary">
					{saleOrderCount} {saleOrderCount === 1 ? 'SaleOrder' : 'SaleOrders'}
					{agencyCount > 0 ? ` · ${agencyCount} ${agencyCount === 1 ? 'agencia' : 'agencias'}` : ''}
					{typeLabel ? ` · Tipo: ${typeLabel}` : ''}
				</Typography>
			</Box>

			<Box sx={{ flex: 1 }} />

			{!isHomogeneous && (
				<Chip label="Seleccioná solo servicios del mismo tipo" color="warning" size="small" variant="outlined" />
			)}

			<Button size="small" startIcon={<ClearIcon />} onClick={onClear}>
				Limpiar
			</Button>
			<Button
				size="small"
				variant="contained"
				startIcon={<EditIcon />}
				onClick={onEdit}
				disabled={!isHomogeneous || count < 2}
			>
				Edición masiva
			</Button>
		</Paper>
	);
};
